import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Insights } from '$components/project/index';
import { showNotification, changeTitle } from '$actions/root';
import { createReport } from '$actions/submissions';
import { getInsight, getInsightFilters, createInsightFilter, deleteInsightFilter, updateInsightFilter, getCustomColumns } from '../../../api';
import { browserHistory } from 'react-router';
import cloneDeep from 'lodash/cloneDeep';
import { Translate } from '$common';

@connect(null, { showNotification, changeTitle, createReport })
export default class InsightsRoute extends Component {
  state = {
    insight: [],
    filters: {
      age_range: {},
      min_age: "",
      max_age: "",
      gender: { male: false, female: false },
      expression: {
        left: {},
        operator: "",
        right: {}
      },
      custom_field_key: "",
      custom_field_value: ""
    },
    savedFilters: [],
    customColumns: []
  };

  parseFilters() {
    const { location } = this.props;
    let query = JSON.parse(location.query.q || "{}");

    delete query.is_custom_age_range_enabled;

    if (query.expression) {
      if (query.expression.left) {
        delete query.expression.left.question_id;
      }

      if (query.expression.right) {
        delete query.expression.right.question_id;
      }
    }

    return query;
  }

  async loadData() {
    const { params, location } = this.props;
    const filters = this.parseFilters();

    const { data: insight } = await getInsight(params.id, params.taskFormId, filters);
    const { data: allTaskForms } = await getInsight(params.id);

    this.setState({ 
      insight,
      filters: JSON.parse(location.query.q || "{}"),
      taskForms: allTaskForms.task_forms || []
    });
  }

  async loadFilters() {
    const { params } = this.props;
    const { data: savedFilters } = await getInsightFilters(params.id, params.taskFormId);
    this.setState({ savedFilters });
  }

  async loadCustomColumns() {
    const { params } = this.props;
    
    if (params.taskFormId) {
      const { data: customColumns } = await getCustomColumns({ customizable_of_Task_type_task_form_id_eq: params.taskFormId});
      this.setState({ customColumns })
    }
  }

  async saveFilter(values) {
    let clonedFilters = cloneDeep(values);

    clonedFilters.task_form_id = this.props.params.taskFormId;
    clonedFilters.name = clonedFilters.name || `Filter ${this.state.savedFilters.length + 1}`;

    try {
      if (values.id) {
        await updateInsightFilter(values.id, clonedFilters);
      } else {
        await createInsightFilter(clonedFilters);
      }

      this.props.showNotification(Translate.get('filter_saved_success'), 'success');
      this.loadFilters();
    } catch (e) {
      console.error(e);
    }
  }

  async deleteFilter(id) {
    try {
      await deleteInsightFilter(id);
      this.props.showNotification(Translate.get('filter_deleted_success'), 'success');
      this.loadFilters();
    } catch (e) {
      console.error(e);
    }
  }

  createReport({ type }) {
    this.props.createReport(this.props.params.id, type, { task_form_id_eq: this.props.params.taskFormId }, this.parseFilters());
  }

  componentWillMount() {
    const { insight, params, project } = this.props;

    this.props.changeTitle(Translate.get('insights'));

    if (insight.task_forms && !params.taskFormId) {
      const taskForm = insight.task_forms && insight.task_forms[0] || {};
      if (taskForm.id) {
        browserHistory.push(`/project/${project.id}/insights/${taskForm.id}`)
      }
    }

    this.loadData();
    this.loadFilters();
    this.loadCustomColumns();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentWillReceiveProps(nextProps) {
    const { insight, params, project } = nextProps;

    if (JSON.stringify(this.props) !== JSON.stringify(nextProps)) {
      if (insight.task_forms && !params.taskFormId) {
        const taskForm = insight.task_forms && insight.task_forms[0] || {};
        if (taskForm.id) {
          browserHistory.push(`/project/${project.id}/insights/${taskForm.id}`)
        }
      }

      if (!this.interval) {
        const interval = this.interval;
        this.interval = setInterval( () => {
          if (typeof this.state.insight.length === "undefined") {
            clearInterval(interval);
          } else {
            this.loadData();
          }
        }, 10000);

        if (typeof this.state.insight.length === "undefined") {
          clearInterval(this.interval);
        }
      }
    }
  }

  sendFilters(filters) {
    const { id, taskFormId } = this.props.params;

    browserHistory.push({
      pathname: `/project/${id}/insights/${taskFormId}`,
      query: { q: JSON.stringify(filters) }
    });

    setTimeout( () => {
      this.loadData();
    }, 100)
  }

  render() {
    const { project } = this.props;
    const { insight, filters, savedFilters, taskForms, customColumns } = this.state;

    return (
      <Insights
        project={project}
        insight={insight}
        taskFormId={this.props.params.taskFormId || null}
        showNotification={::this.props.showNotification}
        sendFilters={::this.sendFilters}
        filters={filters}
        savedFilters={savedFilters}
        saveFilter={::this.saveFilter}
        deleteFilter={::this.deleteFilter}
        taskForms={taskForms || []}
        createReport={::this.createReport}
        customColumns={customColumns}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/project/insights/insights.js